import {
  FormState,
  PriceCalculationState,
  ProductEntity,
  StoredAdviceCartEntity,
} from "./priceCalculationInterfaces";

import { ReduxState } from "Store/rootReducer";
import { useSelector } from "react-redux";

const priceCalculationSelector = (state: ReduxState): PriceCalculationState =>
  state.priceCalculation;

const storedProductSelector = (state: ReduxState): ProductEntity =>
  state.priceCalculation.storedProduct;

const storedAdviceCartSeletor = (state: ReduxState): StoredAdviceCartEntity =>
  state.priceCalculation.storedAdviceCart;

const formStateSelector = (state: ReduxState, formId: string): FormState =>
  state.priceCalculation.priceCalculationFormStates[formId];

export const useStoredProductSelector = (): ProductEntity =>
  useSelector(storedProductSelector);

export const usePriceCalculationSelector = (): PriceCalculationState =>
  useSelector(priceCalculationSelector);

export const useStoredAdviceCartSelector = (): StoredAdviceCartEntity =>
  useSelector(storedAdviceCartSeletor);

export const useFormStateSelector = (formId: string): FormState =>
  useSelector((state: ReduxState) => formStateSelector(state, formId));
